"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const react_datepicker_1 = __importDefault(require("react-datepicker"));
const date_fns_1 = require("date-fns");
const feed_factory_models_ndtrc_1 = require("@feed-factory/feed-factory.models.ndtrc");
const react_select_1 = __importDefault(require("react-select"));
const WhenWidget_module_scss_1 = __importDefault(require("./WhenWidget.module.scss"));
const react_i18next_1 = require("react-i18next");
const stringHHmmToDate = (value) => {
    if (!value)
        return null;
    const [h, m] = value.split(":");
    if (!h || !m) {
        // also if not date provided
        return null;
    }
    try {
        return new Date(1972, 1, 1, parseInt(h), parseInt(m));
    }
    catch (e) {
        return null; // If int cannot be parsed
    }
};
const WhenWidget = (props) => {
    var _a, _b;
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement("div", { className: WhenWidget_module_scss_1.default.WhenWidget },
        react_1.default.createElement("div", null,
            react_1.default.createElement(react_hook_form_1.Controller, { name: `${props.namespace}.timestart`, control: props.formMethods.control, defaultValue: (_a = props.defaultValue) === null || _a === void 0 ? void 0 : _a.timestart, rules: { required: true }, render: ({ field: { onChange, onBlur, value, name, ref }, fieldState: { invalid, isTouched, isDirty, error }, formState, }) => {
                    return (react_1.default.createElement(react_datepicker_1.default, { selected: stringHHmmToDate(value), onChange: (date) => {
                            onChange(date ? (0, date_fns_1.format)(date, "HH:mm") : null);
                        }, showTimeSelect: true, showTimeSelectOnly: true, locale: "nl", timeIntervals: 15, dateFormat: "HH:mm", disabled: props.disabled || false, className: "time " +
                            ((0, react_hook_form_1.get)(props.formMethods.formState.errors, `${props.namespace}.timestart`) && "fieldError") }));
                } })),
        react_1.default.createElement("div", null,
            react_1.default.createElement(react_hook_form_1.Controller, { name: `${props.namespace}.timeend`, control: props.formMethods.control, defaultValue: (_b = props.defaultValue) === null || _b === void 0 ? void 0 : _b.timeend, render: ({ field: { onChange, onBlur, value, name, ref }, fieldState: { invalid, isTouched, isDirty, error }, formState, }) => {
                    return (react_1.default.createElement(react_datepicker_1.default, { selected: stringHHmmToDate(value), onChange: (date) => {
                            onChange(date ? (0, date_fns_1.format)(date, "HH:mm") : null);
                        }, showTimeSelect: true, showTimeSelectOnly: true, locale: "nl", timeIntervals: 15, dateFormat: "HH:mm", disabled: props.disabled || false, showDisabledMonthNavigation: true, className: "time" }));
                } })),
        !props.noStatus && (react_1.default.createElement("div", null,
            react_1.default.createElement(react_hook_form_1.Controller, { name: `${props.namespace}.status`, control: props.formMethods.control, render: ({ field: { onChange, onBlur, value, name, ref }, fieldState: { invalid, isTouched, isDirty, error }, formState, }) => {
                    const currentSelection = feed_factory_models_ndtrc_1.SingleDateStatus.find((item) => item.value === value);
                    return (react_1.default.createElement(react_select_1.default, { className: `${WhenWidget_module_scss_1.default.singleDateStatusSelect} ${props.disabled ? WhenWidget_module_scss_1.default.isDisabled : ""}`, value: currentSelection, isDisabled: props.disabled || false, isClearable: true, options: feed_factory_models_ndtrc_1.SingleDateStatus, menuPlacement: "auto", placeholder: `${t("form.select")}...`, styles: {
                            menu: (provided, state) => {
                                return Object.assign(Object.assign({}, provided), { zIndex: 2 });
                            },
                        }, onChange: (item) => {
                            onChange(item === null || item === void 0 ? void 0 : item.value);
                        } }));
                } })))));
};
exports.default = WhenWidget;
//# sourceMappingURL=WhenWidget.js.map